import { CloseCircleOutlined } from '@ant-design/icons';
import { Tooltip } from 'antd';
import classNames from 'classnames';
import type { ReactNode } from 'react';

import styles from './CalendarHeader.module.scss';

type Props = {
  label: ReactNode;
  closed?: boolean;
};

export const CalendarHeader = ({ label, closed = false }: Props) => {
  if (closed) {
    return (
      <Tooltip title="Closing period activated">
        <div className={classNames(styles.header, { [styles.closed]: closed })}>
          <span>{label}</span>
          <CloseCircleOutlined className={styles.closedIcon} />
        </div>
      </Tooltip>
    );
  }

  return (
    <div className={classNames(styles.header)}>
      <span>{label}</span>
    </div>
  );
};
